import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import moment from 'moment';

import { formats } from './datetime.js';

i18n.on('languageChanged', lng => moment.locale(lng));

export function setupLocale(options) {
    moment.locale(options.lng);

    i18n.use(initReactI18next).init(
        Object.assign(
            {
                ns: ['common', 'search', 'result'],
                defaultNS: 'common',
                interpolation: {
                    escapeValue: false, // react is already xss safe
                    format: (value, format) => {
                        switch (format) {
                            case 'thousands':
                                return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
                            case 'date':
                                return moment(value).format(formats.READABLE_DATE_FORMAT);
                            case 'dateShort':
                                return moment(value).format(formats.READABLE_DATE_FORMAT_SHORT);
                            case 'dateFull':
                                return moment(value).format(formats.FLIGHT_FULL_DATE_FORMAT);
                            case 'time':
                                return moment(value).format(formats.TIME_FORMAT);
                            case 'dayTime':
                                return moment(value).format(formats.FLIGHT_DAY_TIME_FORMAT);
                        }
                        return value;
                    },
                },
                debug: process.env.NODE_ENV === 'development',
            },
            options
        )
    );
}

export const momentWithLocale = moment;

export default i18n;
